export default __webpack_public_path__ + "static/media/default-banner-mobile.df18ea43.png";